import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

const safeSelector = (rootState: RootState) => rootState.account;
export const accountSelector = createSelector(safeSelector, (account) => account.account);
export const loadingAccountSelector = createSelector(safeSelector, (account) => account.isLoading);
export const errorAccountLoadingSelector = createSelector(safeSelector, (account) => account.error);
export const lastAccessedSiteIdSelector = createSelector(
  safeSelector,
  (account) => account?.account?.last_site_accessed?.name,
);
export const lastAccessedWidgetSelector = createSelector(
  safeSelector,
  (account) => account?.account?.last_widget_accessed?.name,
);

export const accountSiteSelector = createSelector(safeSelector, (account) => account.site);
export const accountConnectedSelector = createSelector(
  safeSelector,
  (account) => account.connected,
);
export const accountConnectedLoadingSelector = createSelector(
  safeSelector,
  (account) => account.connectedLoading,
);
export const accountConnectedErrorSelector = createSelector(
  safeSelector,
  (account) => account.connectedError,
);
export const accountRoleSelector = createSelector(safeSelector, (account) => account.role);

// Role-specific selectors for permission checks
export const isAdminOrOwnerSelector = createSelector(
  accountSelector,
  (account) => account?.roles?.includes('ADMIN') || account?.roles?.includes('OWNER'),
);

export const hasRequestEventCreationRoleSelector = createSelector(accountSelector, (account) =>
  account?.roles?.includes('REQUEST_EVENT_CREATION'),
);

export const isEventManagerSelector = createSelector(accountSelector, (account) =>
  account?.roles?.includes('EVENT_MANAGER'),
);

export const isEventHostManagerSelector = createSelector(accountSelector, (account) =>
  account?.roles?.includes('EVENT_HOST_MANAGER'),
);
